<template>
  <div>
    <marketplace-card-slider v-model="selectedMarketplace" class="pa-3" />

    <!-- ارسال marketplace و store_id جاری به کامپوننت فعال -->
    <component
      :is="activeComponent"
      v-if="activeComponent"
      :key="componentKey"
      :marketplace="currentType"
      :store_id="currentStoreId"
    />
  </div>
</template>

<script>
import MarketplaceCardSlider from "../../../components/MarketplaceCardSlider.vue";
import General_settings from "./general_settings.vue";
import SettingsPage from "./SettingsPage.vue";

export default {
  name: "SettingsPageAll",
  components: {
    MarketplaceCardSlider,
    SettingsPage,
    General_settings,
  },
  data: () => ({
    // مقدار اولیه به صورت آبجکت هماهنگ با خروجی اسلایدر
    selectedMarketplace: {
      type: "digikala",
      store_id: null,
    },
    items: [
      { title: "general_settings", component: "General_settings" },
      { title: "digikala", component: "SettingsPage" },
      { title: "technolife", component: "SettingsPage" },
      { title: "snappshop", component: "SettingsPage" },
      { title: "divar", component: "SettingsPage" },
      { title: "physical_store", component: "SettingsPage" },
      { title: "woocommerce", component: "SettingsPage" },
      { title: "basalam", component: "SettingsPage" },
      { title: "torob", component: "SettingsPage" },
      { title: "emalls", component: "SettingsPage" },
      { title: "sheypoor", component: "SettingsPage" },
    ],
  }),
  computed: {
    currentType() {
      if (!this.selectedMarketplace) return "digikala";
      return typeof this.selectedMarketplace === "object"
        ? this.selectedMarketplace?.type
        : this.selectedMarketplace;
    },
    currentStoreId() {
      if (!this.selectedMarketplace || typeof this.selectedMarketplace !== "object") return null;
      return this.selectedMarketplace.store_id || null;
    },
    activeComponent() {
      const type = this.currentType;
      const found = this.items.find((x) => x.title === type);
      return found ? found.component : "SettingsPage";
    },
    componentKey() {
      return `${this.currentType}_${this.currentStoreId}`;
    },
  },
};
</script>
